import React from 'react';
import HeaderBody from './headerBody';
import Navbar from '../utils/navbar';
import SwipeHeader from '../utils/swipeHeader';
import {constantStyles} from '../constants/constantStyles';

const Header = () => {
    return (
        <header>
            <SwipeHeader />
            <HeaderBody />
            <Navbar />
        </header>
    );
};

export default Header;